import {
  Box,
  Button,
  CheckIcon,
  Flex,
  PartnerLogo,
  Typography,
} from '@iheartjane/reefer';
import { useMemo } from 'react';

import type { SpecialPdpCalloutProps } from './SpecialPdpCallout.types';

export const SpecialPdpCallout = ({
  brandName,
  isGold,
  onClick,
  partnerLogo,
  showButton,
  showCheck,
  specialTypeLabel,
  title,
}: SpecialPdpCalloutProps) => {
  const completeText = useMemo(() => {
    return `Complete ${isGold ? 'bundle' : 'deal'}`;
  }, [isGold]);

  return (
    <Flex
      border="transparent-black-five"
      borderRadius="lg"
      width="100%"
      flexDirection="row"
      gap={16}
      p={16}
      alignItems="center"
      aria-label={`view ${title} special`}
      onClick={onClick}
    >
      {isGold && brandName && (
        <PartnerLogo
          variant="brand"
          name={brandName}
          image={partnerLogo}
          size="xs"
        />
      )}
      <Box overflow="hidden">
        {!isGold && specialTypeLabel && (
          <Typography color="info">{specialTypeLabel}</Typography>
        )}
        <Typography variant="body-bold">{title}</Typography>
      </Box>

      {showButton ? (
        <Button ml="auto" label={completeText} variant="tertiary" />
      ) : showCheck ? (
        <Flex ml="auto">
          <CheckIcon />
          <Typography ml={8}>Applied</Typography>
        </Flex>
      ) : null}
    </Flex>
  );
};
